<script>
  import { onMount } from "svelte";
  import {
    actionTypes,
    addHash,
    decorateAction,
    localeOrderBy,
    slice,
    loadPersisted,
    savePersisted,
  } from "../../mjnUtils";
  import Pagination from "./pagination/Pagination.svelte";

  let { http, toastr, search, openModal } = $props();

  const actionIcons = {
    1: "fas fa-arrow-alt-circle-right",
    2: "fas fa-eraser",
    3: "far fa-clock",
  };

  let actions = $state([]);
  let members = $state([]);
  let searchText = $state("");
  let sortType = $state(loadPersisted("actions", "sortType", "data_od"));
  let sortReverse = $state(loadPersisted("actions", "sortReverse", true));
  let currentPage = $state(1);
  const itemsPerPage = 11;

  $effect(() => {
    savePersisted("actions", "sortType", sortType);
    savePersisted("actions", "sortReverse", sortReverse);
  });

  onMount(() => {
    Promise.all([http.get("/api/czlonek.php"), http.get("/api/akcja.php")]).then(
      ([membersResponse, actionsResponse]) => {
        if (
          membersResponse.data.status == 200 &&
          actionsResponse.data.status == 200
        ) {
          members = addHash(membersResponse.data.records, "idcz");
          actionsResponse.data.records.forEach((action) =>
            decorateAction(action, members, actionTypes),
          );
          actions = actionsResponse.data.records;
        } else {
          toastr.error(
            "Błąd: " +
              membersResponse.data.message +
              ", " +
              actionsResponse.data.message,
          );
        }
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  });

  let filteredActions = $derived(search(actions, searchText));
  let sortedActions = $derived(localeOrderBy(filteredActions, sortType, sortReverse));
  let totalItems = $derived(filteredActions.length);
  let numPages = $derived(Math.max(1, Math.ceil(totalItems / itemsPerPage)));
  let pagedActions = $derived(slice(sortedActions, itemsPerPage, currentPage));
  let sortedMembers = $derived(localeOrderBy(members, "nazwisko", false));

  $effect(() => {
    searchText;
    currentPage = 1;
  });

  function setSort(field) {
    if (sortType === field) {
      sortReverse = !sortReverse;
    } else {
      sortType = field;
      sortReverse = false;
    }
  }

  function editAction(action) {
    openModal("ActionEditModal", {
      action,
      members: sortedMembers,
      types: actionTypes,
    }).then(
      (editedItem) => {
        if (!editedItem) return;
        if (editedItem.hasOwnProperty("idak")) {
          http.put("/api/akcja.php", editedItem).then(
            (response) => {
              if (response.data.status == 200) {
                toastr.info("Edycja zakończona sukcesem");
                decorateAction(editedItem, members, actionTypes);
                actions = actions.map((a) =>
                  a.idak === editedItem.idak ? editedItem : a,
                );
              } else {
                toastr.error("Błąd: " + response.data.message);
              }
            },
            () => {
              toastr.error("Błąd połączenia");
            },
          );
        } else {
          http.post("/api/akcja.php", editedItem).then(
            (response) => {
              if (response.data.status == 200) {
                const inserted = response.data.records[0];
                decorateAction(inserted, members, actionTypes);
                actions = [...actions, inserted];
                toastr.info(
                  'Utworzono nową akcję "' +
                    inserted.typ_text +
                    '" dla ' +
                    inserted.idcz_text,
                );
              } else {
                toastr.error("Błąd: " + response.data.message);
              }
            },
            () => {
              toastr.error("Błąd połączenia");
            },
          );
        }
      },
      () => {},
    );
  }

  function deleteAction(action) {
    if (
      confirm(
        "Skasować akcję nr " +
          action.idak +
          ', "' +
          action.typ_text +
          '" dla ' +
          action.idcz_text +
          "?",
      )
    ) {
      http.delete("/api/akcja.php?id=" + action.idak).then(
        (response) => {
          if (response.data.status == 200) {
            actions = actions.filter((a) => a.idak !== action.idak);
            toastr.info(
              'Skasowano akcję "' + action.typ_text + '" dla ' + action.idcz_text,
            );
          } else {
            toastr.error("Błąd: " + response.data.message);
          }
        },
        () => {
          toastr.error("Błąd połączenia");
        },
      );
    }
  }
</script>

<h3><i class="fas fa-briefcase-medical fa-lg"></i>&nbsp;&nbsp;Umorzenia, zawieszenia
<div class="btn-toolbar pull-right">
<button class="btn btn-primary btn-sm pull-right" onclick={() => editAction({})} title="Otwiera okienko, w którym można zdefiniować nowe umorzenie bądź zwolnienie ze składek. Jeśli chcesz umorzyć komuś wszystkie zaległości, ustaw mu saldo na zero.">
    <i class="fas fa-plus" aria-hidden="true"></i>
    <span class="hidden-xs">&nbsp;Dodaj nową akcję...</span></button>
</div>
</h3>
<div class="clearfix"></div>
<div class="text-left"><small><i class="fas fa-random" aria-hidden="true"></i>
W tej chwili mamy {actions.length} zdefiniowanych umorzeń/zawieszeń{#if searchText != ""}, {filteredActions.length} przefiltrowanych poniżej{/if}.
</small><p></p></div>

<form>
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-addon"><i class="fas fa-search"></i></div>
        <input type="text" class="form-control input-sm" placeholder="Wyszukaj akcję" bind:value={searchText}>
      </div>
    </div>
</form>

<table class="table table-condensed table-hover table-striped">

    <thead class="thead-default">
      <tr>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("idcz_sort_text"); }}>
          Dotyczy osoby
          {#if sortType == "idcz_sort_text" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "idcz_sort_text" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs hidden-sm">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("typ_text"); }}>
          Typ
          {#if sortType == "typ_text" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "typ_text" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("data_od"); }}>
          Data lub zakres
          {#if sortType == "data_od" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "data_od" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("kwota"); }}>
          Kwota
          {#if sortType == "kwota" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "kwota" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("uchwala"); }}>
          Uchwała
          {#if sortType == "uchwala" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "uchwala" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          Operacje
        </th>
      </tr>
    </thead>

    <tbody>
      {#each pagedActions as action (action.idak)}
      <tr>
        <td>
            <i class="{actionIcons[action.typ]} fa-lg fa-fw" aria-hidden="true" style="margin: 6px 0px 8px 0px;"></i>&nbsp;&nbsp;
            <a href={"/member-detail/" + action.idcz}>
                {action.idcz_text}
            </a>
        </td>
        <td class="hidden-xs hidden-sm">
        {action.typ_text}
        </td>
        <td>
        {action.data_od} {action.typ != 3 ? "" : (action.data_do === null ? "do odwołania" : "- " + action.data_do)}
        </td>
        <td>
        {action.kwota}
        </td>
        <td class="hidden-xs">
        {action.uchwala}
        </td>
        <td>
            <a href="#" onclick={(e) => { e.preventDefault(); editAction(action); }} title="Edycja umorzenia/zwolnienia"><i class="fas fa-pen-square fa-lg fa-fw"></i></a>
            <a href="#" onclick={(e) => { e.preventDefault(); deleteAction(action); }} title="Skasuj umorzenie/zwolnienie"><i class="fas fa-trash fa-lg fa-fw"></i></a>
        </td>
      </tr>
      {/each}
    </tbody>

</table>
<Pagination {currentPage} {numPages} onPageChange={(page) => currentPage = page}/>
